// @ts-ignore
// Global de public/index.html (cdnjs); puede faltar (CDN caído, jsdom): solo falla el visor, no la SPA.
const pdfjs = window.pdfjsLib;

if (pdfjs) {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
}

export const pdf = pdfjs;
